import { LOGIN_USER,UPDATE_USER_DATA } from "../constants/actions-types";
import { enviaApi } from "../../utils";

const default_login = {
	user: "",
	token:""
};

function loginReducer(state = default_login, action){
	if(action.type === LOGIN_USER){
		let newLogin = {...state};
		newLogin.user = action.usuario.user;
		newLogin.token = action.usuario.token;
		if(newLogin.user.acf && (!newLogin.user.acf.fecha_alta || newLogin.user.acf.fecha_alta === ""))
			enviaApi("acf/v3/users/"+newLogin.user.id,"PUT",JSON.stringify({"fields":{"fecha_alta":Date.now()}}),newLogin.token);
		return newLogin;
	}
	if(action.type === UPDATE_USER_DATA){
		if(state.user.acf){
			let newData = {...state.user.acf};
			if(newData[action.datos.field] !== action.datos.value){
				newData[action.datos.field] = action.datos.value;
				enviaApi("acf/v3/users/"+state.user.id,"PUT",JSON.stringify({"fields":newData}),state.token);
			}
			let newUser = {...state.user};
			newUser.acf = newData;
			let newState = {...state};
			newState.user = newUser;
			return newState;
		}
	}
	return state;
}

export default loginReducer;